import {
  TMeeting,
  TCreateMeetingPayload,
  TMeetingsResponse,
  TMeetingsFilters,
} from "@/models/meetings.model";
import axios from "@utils/axios-instance";

const create = async (data: TCreateMeetingPayload): Promise<TMeeting> => {
  const response = await axios.post("/meeting", data);
  return response.data;
};

const getAll = async (filters: TMeetingsFilters = {}): Promise<TMeetingsResponse> => {
  const cleanFilters = Object.fromEntries(
    Object.entries(filters).filter(([, val]) => val !== undefined && val !== null && val !== "")
  );
  const queryString = new URLSearchParams(cleanFilters as Record<string, string>).toString();
  const response = await axios.get(`/meeting${queryString ? `?${queryString}` : ""}`);
  return response.data;
};

const updateById = async (
  id: number,
  data: Partial<Omit<TMeeting, "id" | "uuid" | "companyId" | "created" | "updated">>
): Promise<TMeeting> => {
  const response = await axios.patch(`/meeting/${id}`, data);
  return response.data;
};

const setStatusById = async (
  id: number,
  status: string,
  reason?: string
): Promise<TMeeting> => {
  const response = await axios.patch(`/meeting/${id}/status`, {
    status,
    reason,
  });
  return response.data;
};

const deleteById = async (id: number): Promise<void> => {
  await axios.delete(`/meeting/${id}`);
};

export default {
  create,
  getAll,
  updateById,
  setStatusById,
  deleteById,
};
